import React, { useState } from 'react'
import gql from 'graphql-tag'
import { useMutation } from '@apollo/react-hooks'
import { Modal, Button } from 'react-bootstrap'
import PropTypes from 'prop-types'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'

const reload = () => window.location.reload()

const AGOL_TASK = gql`
    mutation triggerAgolTask($input: triggerAgolTaskInput!) {
        triggerAgolTask(input: $input) {
        itemId
        fileName
        taskInitialized
        statusCode
        }
    }
`

export default function AgolServiceModal(props) {

  const [isLoading, setIsLoading] = useState(false)
  const [isComplete, setIsComplete] = useState(false)
  const [showClose, setShowClose] = useState(false)

  const handleClose = () => {
    props.onHide()
    reload()
  }

  let title
  let body

  const dataAction = props.action
  if (dataAction === 'delete'){
    title = 'Unpublish Service from USGS ArcGIS Online'
    body = <div><p>You are about to unpublish the following .sd file from the USGS ArcGIS Online (AGOL) space: {props.row.name}</p>
    <br/>
    <p>The process of stopping a map service from an ESRI .sd file may take a few minutes. You will receive an email (sent to the email associated with your ScienceBase user account) indicating the status of the unpublishing job when it is complete. Successful service unpublishing will also be reflected in the ScienceBase item at that time (I.e., AGOL map service URIs will be removed from the item JSON and show page).</p></div>
  }else if (dataAction === 'publish' ){
    title = 'Publish Service Definition to USGS ArcGIS Online'
    body = <div><p>You are about to publish the following .sd file to the USGS ArcGIS Online (AGOL) space: {props.row.name}</p>
    <br/>
    <p>The process of starting a map service from an ESRI .sd file may take several minutes. You will receive an email (sent to the email associated with your ScienceBase user account) indicating the status of the publishing job when it is complete. Successful service generation will also be reflected in the ScienceBase item at that time (I.e., AGOL map service URIs will be added to the item JSON and show page).</p>
    <br/>
    <p>Before proceeding, please confirm that the content being published does <b>not</b> contain Personally Identifiable Information (PII) or Controlled Unclassified Information (CUI). This type of content is prohibited from being hosted in the USGS ArcGIS Online instance.</p>
    <br/>
    <p>Please note that to be compatible with the USGS AGOL space, .sd files need to be made while a user is signed into an organizational account. Additionally, .sd filenames must be globally unique with the USGS AGOL space. The name must be established internally in the file when creating the .sd simply re-naming a file on disk will not resolve naming conflicts.</p></div>
  }

  const [agol_task] = useMutation(
      AGOL_TASK,
      {
              variables: {
                      input: {
                              itemId: props.itemId,
                              fileName: props.row.name,
                              taskType: dataAction
                      }
              }
      }
  )

  return (
    <Modal {...props} size='lg'>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {body}
        <form
          onSubmit= {e => {
            setIsLoading(true)
            e.preventDefault()
            agol_task().then(              
              result => {
                console.log('result', result)
                reload()
              },
              error => {
                console.log('{title} failed with error: ', error)
                props.onHide()
                setIsLoading(false)
              }
            )
          }}
        >
          <h3>You are about to {title}: {props.row.name}</h3>
          <Modal.Footer>
            <Button variant='secondary' onClick={props.onHide}>Close</Button>
            {isComplete ? '' : <Button variant="primary" type="submit">{isLoading ? <span ><FontAwesomeIcon icon={faSpinner} pulse /></span> : ''}&nbsp;{title} </Button>}
            </Modal.Footer>
        </form>
      </Modal.Body>
    </Modal>
  )
}

AgolServiceModal.propTypes = {
  row: PropTypes.shape({
    name: PropTypes.string,
    id: PropTypes.string,
    pathOnDisk: PropTypes.string,
    contentType: PropTypes.string,
    scrapeMetadata: PropTypes.any,
    status: PropTypes.shape({
      scanPassed: PropTypes.bool
    })
  }),
  itemId: PropTypes.string,
  onHide: PropTypes.func,
  action: PropTypes.string,
}
